import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useImperativeHandle,
} from 'react';
import { NavLink } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import bot_icon from './../../../../../assets/bot_icon.png';
import {
  Card,
  CardBody,
  CardTitle,
  Badge,
  CardImg,
  Button,
  Row,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  InputGroup,
  InputGroupAddon,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  CustomInput,
  UncontrolledDropdown,
} from 'reactstrap';
import {
  gAPI_TicketsRecording_id,
  postAPI_Ticket_SendText,
  postAPI_Create_QuickReply,
  gAPI_QuickReplyDelete_ById,
  Upload_Email_Attachment,
  putAPI_UpdateChatStatus_By_Id,
  pAPI_Update_Message,
} from '../../../../../constants/APIs';
import {
  AxiosAPI,
  getGroupID,
  getUserID,
  AxiosPublicAPI,
} from '../../../../../helpers/AxiosAPI';
import IntlMessages from '../../../../../helpers/IntlMessages';
import moment from 'moment';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import Select from 'react-select';
import ChatMessage from '../../../../../components/chats/ChatMessage';
import {
  reactSelectOption,
  reactSelectOptionDiffrentPro,
} from '../../../../../helpers/Utils';
import { ref } from 'yup';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.bubble.css';
import AutonomousReplies from '../../agentAssist/Components/EmailAssistant/autonomousReplies';
import UploadAttachments from '../../agentAssist/Components/EmailAssistant/uploadAttachments';
import Templates from '../../agentAssist/Components/EmailAssistant/templates';
const TWILIO_END_CONVERSATION =
  process.env.REACT_APP_CHAT_API + '/endTwilioConversation';
const TWILIO_CHECKCHAT_URL = process.env.REACT_APP_CHAT_API + '/checkchat';
const quillModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link', 'image'],
    ['clean'],
  ],
};
const quillFormats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
];

const styles = `
    .ql-toolbar {
       border: 0px!important;
       background: rgb(233, 238, 244);
  border-radius: 20px;
    }

    .ql-editor {
      min-height: 20px !important;
    max-height: 300px !important;
  overflow-y: auto;
    }

    .ql-container{
      border: 0px!important;
      background: rgb(233, 238, 244);
    } 
`;

const Chat = React.forwardRef(
  (
    {
      chat,
      emailIntegration,
      accessToken,
      twilioConversations,
      twilioChatId,
      forceRefresh,
      closeTwilioConversation,
      profileName,
      userName,
      propertyId,
      locale,
      stopBlink,
      chatReplyTemplates,
      setBlankTwilioId,
      availabilityIntegration,
    },
    ref
  ) => {
    const [showTemplate, setShowTemplate] = useState(false);
    const [uploadAttachment, setUploadAttchment] = useState(false);
    const [files, setFiles] = useState();
    const [replayDivHeight, setReplayDivHeight] = useState(20);
    const [messages, setMessages] = useState([]);
    const [isTyping, setTyping] = useState(false);
    const [newmessage, setNewMessae] = useState('');
    const [twilioChatClient, setTwilioChatClient] = useState(null);
    const [quickReplies, setQuickReplies] = useState(chatReplyTemplates || []);
    const messagesEndRef = useRef(null);
    const stateRef = useRef();
    stateRef.current = twilioChatId;

    useImperativeHandle(ref, () => ({
      loadNewMessage(message) {
        loadNewMessage(message);
      },
    }));
    const handleChange = (e) => {
      setNewMessae(e.target.value);
      twilioChatClient.typing();
    };
    const handleUploadAttachment = () => setUploadAttchment(!uploadAttachment);

    const handleTemplate = () => setShowTemplate(!showTemplate);

    const handleFiles = (list) => setFiles(list);
    const saveAsDraft = () => {
      if (
        messages != null &&
        messages.length > 0 &&
        messages.filter((f) => f.isDraft !== undefined && f.isDraft === true)
          .length > 0
      ) {
        updateDraftMessage(true);
      } else {
        sendMessage(true);
      }
    };

    const updateDraftMessage = (draft, attachments) => {
      if (
        messages.filter((f) => f.isDraft !== undefined && f.isDraft === true)
          .length > 0
      ) {
        let obj = messages.filter(
          (f) => f.isDraft !== undefined && f.isDraft === true
        )[0];
        AxiosAPI({
          method: 'put',
          url: `${pAPI_Update_Message}/${obj.messageId}`,
          data: {
            isDraft: draft,
            attachments: attachments,
            groupId: getGroupID(),
            content: {
              type: 'message-email',
              messages: [newmessage],
            },
          },
        }).then((res) => { });
      }
    };

    const sendMessage = async (draft = false) => {
      if (chat?.channel !== 'EmailDirectLine') {
        twilioChatClient.sendMessage(newmessage);
        stopBlink();
        setNewMessae('');
      } else if (newmessage !== '') {
        let attachments = [];
        if (files !== undefined && files.length > 0) {
          const result = await handleAttachmentUpload(chat?.sessionId);
          if (result?.data && result.data.length > 0) {
            result.data.map((m) => {
              attachments.push({
                shortName: m.shortName,
                fileName: m.fileName,
                contentType: m.contentType,
              });
            });
          }
        }
        let email = '';
        if (emailIntegration !== undefined) {
          email = emailIntegration?.channelDetails?.forwardingEmail;
        }
        let body = {
          gid: getGroupID(),
          iid: chat?.integrationId,
          pid: chat?.propertyId,
          vid: chat?.visitorId,
          asDraft: draft,
          sid: chat?.sessionId,
          fromEmail: email,
          emailContent: newmessage,
          recipients: chat?.visitor?.email,
          from: userName + ' from Myma.ai <' + email + '>',
          toEmail: chat?.visitor?.email,
          attachments: attachments,
          subject: chat?.visitor?.subject,
          time: moment(),
          messageThreadId: chat?.messageThreadId,
          source: 'Bot',
          message: {
            type: 'message-email',
            messages: [newmessage],
          },
        };
        if (!isDraftMessage()) {
          let url = '';
          if (draft) url = `${process.env.REACT_APP_CHAT_API}/save-draft`;
          url = `${process.env.REACT_APP_CHAT_API}/save-email-reply`;
          AxiosPublicAPI({
            method: 'post',
            url: url,
            data: body,
          }).then((res) => {
            if (!draft) setNewMessae('');
          });
        } else {
          let url = `${process.env.REACT_APP_CHAT_API}/send-draft-email`;
          AxiosPublicAPI({
            method: 'post',
            url: url,
            data: body,
          }).then((res) => {
            updateDraftMessage(false, attachments);
            if (!draft) setNewMessae('');
          });
        }
      }
    };

    const handleAttachmentUpload = async (sessionId) => {
      const data = new FormData();
      files.forEach((file) => {
        data.append('files', file.img);
      });
      data.append('sessionId', sessionId);
      data.append('creator', 'dashboard');
      return await AxiosAPI({
        method: 'post',
        url: `${Upload_Email_Attachment}`,
        data: data,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    };

    const isDraftMessage = () => {
      if (
        messages != null &&
        messages.length > 0 &&
        messages.filter((f) => f.isDraft !== undefined && f.isDraft === true)
          .length > 0
      )
        return true;
      else return false;
    };

    const loadNewMessage = (message) => {
      setMessages((messages) => [...messages, message]);
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    };

    const closeChat = () => {
      twilioChatClient.sendMessage(
        `Agent ${profileName} has left the conversation`
      );
      // fetch(TWILIO_END_CONVERSATION, {
      //   method: 'POST',
      //   headers: {
      //     Accept: 'application/json',
      //     'Content-Type': 'application/json',
      //   },
      //   body: JSON.stringify({ twilioConversationId: twilioChatId }),
      // }).then((res) => {});
      setTwilioChatClient(null);
      closeTwilioConversation(
        stateRef.current,
        chat.conversationId,
        chat.channel
      );
      stopBlink();
    };
    useEffect(() => {
      if (chat) {
        let messages = chat.messages;
        messages.map((m) => {
          if (chat?.fullMessages) {
            let obj = chat?.fullMessages.filter(
              (f) => f.messageId === m.messageId
            );

            if (obj.length > 0 && obj[0]?.metadata) {
              try {
                obj[0].metadata.attachments = JSON.parse(
                  obj[0].metadata.attachments
                );
              } catch {
                obj[0].metadata.attachments = [];
              }
            }
            if (obj.length > 0) m.metadata = obj[0].metadata;
          }
        });
        setMessages(messages);
        if (
          chat.messages != null &&
          chat.messages.length > 0 &&
          chat.messages.filter(
            (f) => f.isDraft !== undefined && f.isDraft === true
          ).length > 0
        ) {
          let obj = chat.messages.filter(
            (f) => f.isDraft !== undefined && f.isDraft === true
          )[0];
          setNewMessae(obj?.text);
        } else {
          setNewMessae('');
        }
      }
    }, [chat]);

    useEffect(() => {
      if (twilioChatId !== '') {
        const selectedConversation = twilioConversations.find(
          (it) => it.sid === twilioChatId
        );

        if (selectedConversation !== undefined) {
          setTwilioChatClient(selectedConversation);
          if (selectedConversation._events.messageAdded.length === 0) {
            selectedConversation.on('messageAdded', (m) => messageAdd(m));
            selectedConversation.on('typingStarted', (m) => startTyping(m));
            selectedConversation.on('typingEnded', (m) => endTyping(m));
          }
        } else {
          AxiosPublicAPI({
            method: 'get',
            url: `${TWILIO_CHECKCHAT_URL}/${twilioChatId}`,
          }).then((t) => {
            if (t.data.status !== 'active') {
              setBlankTwilioId();
            }
          });

          setTwilioChatClient(null);
        }
      } else {
        setTwilioChatClient(null);
      }
    }, [twilioChatId, forceRefresh]);

    const messageAdd = (message) => {
      if (message.conversation.sid === stateRef.current) {
        var m = {
          sender: message.state.author === getUserID() ? false : true,
          source: message.state.author === getUserID() ? 'Bot' : 'Visitor',
          text: message.state.body,
          time: moment(message.state.timestamp),
          type: 'messages',
        };
        setMessages((messages) => [...messages, m]);
        if (messagesEndRef !== undefined && messagesEndRef.current !== null) {
          messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
        if (message.state.body === 'The user has left the conversation.') {
          setTwilioChatClient(null);
          closeTwilioConversation(
            stateRef.current,
            chat.conversationId,
            chat.channel
          );
        }
      }
    };

    const startTyping = (message) => {
      if (message.conversation.sid === stateRef.current) {
        setTyping(true);
      }
    };

    const endTyping = (message) => {
      if (message.conversation.sid === stateRef.current) {
        setTyping(false);
      }
    };

    const handleKeyPress = (target) => {
      if (target.charCode == 13) {
        sendMessage();
      }
    };

    const handleChangeTemplate = (id) => {
      const reply = quickReplies.filter((m) => m.id === id);
      if (reply.length > 0) {
        setNewMessae(reply[0].message);
      }
    };

    useEffect(() => {
      if (accessToken !== '') {
      }
    }, [accessToken]);

    const handleMessage = (source, e) => {
      if (source === 'user') setNewMessae(e);
    };
    return (
      <Fragment>
        {chat?.channel !== 'EmailDirectLine' ? (
          <Card
            className="cardHeightActive card-box"
            style={{
              //overflow: 'scroll',
              backgroundColor: chat ? `${chat.colours.botBackground}` : '#fff',
            }}
          >
            <CardBody style={{ height: '100%' }}>
              <div
                className={`scroll ${twilioChatClient !== null && twilioChatClient !== undefined
                  ? 'divHeightActive'
                  : 'divHeight'
                  }`}
              >
                {chat && (
                  <div>
                    {messages != null &&
                      messages.length > 0 &&
                      messages.map((item, index) => {
                        return (
                          <ChatMessage
                            key={index}
                            sender={item.sender}
                            item={item}
                            avatar={
                              chat.channel === 'PhoneSuite'
                                ? bot_icon
                                : chat.avatar
                            }
                            colors={chat.colours}
                          />
                        );
                      })}
                  </div>
                )}
                <div ref={messagesEndRef} />
              </div>

              {twilioChatClient !== null && twilioChatClient !== undefined && (
                <Fragment>
                  <InputGroup
                    className="mt-3"
                    style={{ position: 'absolute', left: 0, bottom: 0 }}
                  >
                    <Input
                      type="text"
                      value={newmessage}
                      onChange={handleChange}
                      placeholder={'Type your message here...'}
                      autoComplete={'off'}
                      onKeyPress={handleKeyPress}
                    />
                    {quickReplies && quickReplies.length > 0 && (
                      <UncontrolledDropdown addonType="prepend">
                        <DropdownToggle
                          caret
                          color="light"
                          size="m"
                          style={{ backgroundColor: '#fff' }}
                          className="quick"
                        ></DropdownToggle>
                        <DropdownMenu className="quick">
                          {quickReplies.map((element, index) => {
                            return (
                              <DropdownItem
                                onClick={() => handleChangeTemplate(element.id)}
                                key={index}
                              >
                                {element.name}
                              </DropdownItem>
                            );
                          })}
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    )}
                    <InputGroupAddon addonType="prepend">
                      <Button onClick={() => sendMessage()}>Send</Button>
                      <Button
                        style={{ marginLeft: '5px' }}
                        color="danger"
                        onClick={closeChat}
                      >
                        End
                      </Button>
                    </InputGroupAddon>
                    {isTyping && (
                      <div class="typing-indicator-inline">
                        <div class="typing-indicator-disp">
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                      </div>
                    )}
                  </InputGroup>

                  {/* <p className="user-typing">{isTyping && 'User is typing...'}</p> */}
                </Fragment>
              )}
            </CardBody>
          </Card>
        ) : (
          <Card
            className="cardHeightActive"
            style={{
              //overflow: 'scroll',
              backgroundColor: chat ? `${chat.colours.botBackground}` : '#fff',
            }}
          >
            <style>{styles}</style>
            <CardBody style={{ height: `100%` }}>
              <div
                className={`scroll mail-div ${twilioChatClient !== null && twilioChatClient !== undefined
                  ? 'divHeightActive'
                  : 'divHeight'
                  }`}
                style={{
                  height: `${chat?.status === 'Opened' ? '75%' : '100%'}`,
                  overflowX: 'hidden',
                  paddingBottom: '0.5rem',
                }}
              >
                {chat && (
                  <Fragment>
                    {messages != null &&
                      messages.length > 0 &&
                      messages
                        .filter(
                          (f) => f.isDraft === undefined || f?.isDraft === false
                        )
                        .map((item, index) => {
                          return (
                            <ChatMessage
                              key={index}
                              sender={item.sender}
                              item={item}
                              visitor={chat?.visitor}
                              channel={chat?.channel}
                              metadata={item?.metadata}
                              avatar={
                                chat.channel === 'PhoneSuite'
                                  ? bot_icon
                                  : chat.avatar
                              }
                              colors={chat.colours}
                            />
                          );
                        })}
                  </Fragment>
                )}
                <div ref={messagesEndRef} />
              </div>

              {chat?.status === 'Opened' && (
                <div style={{ height: `${replayDivHeight}%` }}>
                  {' '}
                  <Row
                    style={{
                      border: '1px solid black',
                      borderRadius: '20px',
                      margin: '0px 0px 10px 0px',
                      position: 'absolute',
                      bottom: '0px',
                      width: '93%',
                    }}
                  >
                    {' '}
                    <ReactQuill
                      theme="snow"
                      style={{
                        width: '100%',
                        height: '100%',
                      }}
                      value={newmessage}
                      onChange={(content, delta, source) =>
                        handleMessage(source, content)
                      }
                      modules={quillModules}
                      formats={quillFormats}
                      placeholder="Reply"
                      name="message"
                    />
                    <Colxx md="8" className="my-2 text-right">
                      {/* {quickReplies && quickReplies.length > 0 && (
                        <UncontrolledDropdown addonType="append">
                          <DropdownToggle
                            caret
                            color="light"
                            size="m"
                            style={{ backgroundColor: '#fff' }}
                            className="quick"
                          ></DropdownToggle>
                          <DropdownMenu className="quick">
                            {quickReplies.map((element, index) => {
                              return (
                                <DropdownItem
                                  onClick={() =>
                                    handleChangeTemplate(element.id)
                                  }
                                  key={index}
                                >
                                  {element.name}
                                </DropdownItem>
                              );
                            })}
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      )} */}
                      {emailIntegration &&
                        emailIntegration?.channelDetails?.autonomousReplies &&
                        emailIntegration?.channelDetails.autonomousReplies
                          ?.enabled && (
                          <AutonomousReplies
                            propertyId={chat?.propertyId}
                            messages={chat?.messages}
                            sessionId={chat?.sessionId}
                            conversationId={chat?.conversationId}
                            locale={locale}
                            handleMessage={(source, content) =>
                              handleMessage(source, content)
                            }
                            channelDetails={emailIntegration?.channelDetails}
                          ></AutonomousReplies>
                        )}
                      <div
                        onClick={handleUploadAttachment}
                        className="quill-footer-button"
                        title='Attach File'
                      >

                        <i className="simple-icon-paper-clip"></i>
                        {files !== undefined && files.length > 0 ? (
                          <span className="ml-1">{files.length}</span>
                        ) : null}
                      </div>
                    </Colxx>
                    <Colxx md="4" className="my-2 text-right">
                      <div className="send-div">
                        <Button
                          onClick={() => sendMessage()}
                          disabled={
                            newmessage !== '' && newmessage !== '<p><br/></p>'
                              ? false
                              : true
                          }
                          color="primary"
                          style={{
                            borderRadius: '5px',
                          }}
                          size="xs"
                          outline
                        >
                          Send
                        </Button>
                        <div className="position-relative d-none d-sm-inline-block">
                          <UncontrolledDropdown
                            className="dropdown-menu-right"
                            style={{ borderRadius: '5px' }}
                          >
                            <DropdownToggle
                              style={{
                                borderRadius: '5px',
                                padding: '4px',
                              }}
                              caret={'up'}
                              color="primary"
                              className="btn-xs"
                              outline
                            ></DropdownToggle>
                            <DropdownMenu up>
                              <DropdownItem onClick={saveAsDraft}>
                                Save as draft
                              </DropdownItem>
                              {chatReplyTemplates &&
                                chatReplyTemplates.length > 0 &&
                                chatReplyTemplates.filter(
                                  (f) => f.templateChannel === 'Email'
                                ).length > 0 && (
                                  <DropdownItem onClick={handleTemplate}>
                                    {' '}
                                    Templates{' '}
                                  </DropdownItem>
                                )}
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </div>
                      </div>

                      {chat?.channel !== 'EmailDirectLine' && (
                        <Button
                          style={{ marginLeft: '5px' }}
                          color="danger"
                          size="xs"
                          outline
                          onClick={closeChat}
                        >
                          End
                        </Button>
                      )}
                    </Colxx>
                    {isTyping && (
                      <div class="typing-indicator-inline">
                        <div class="typing-indicator-disp">
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                      </div>
                    )}
                  </Row>
                </div>
              )}
            </CardBody>
          </Card>
        )}
        {uploadAttachment && (
          <UploadAttachments
            visible={uploadAttachment}
            files={files}
            toggleModal={handleUploadAttachment}
            handleFiles={(e) => handleFiles(e)}
          ></UploadAttachments>
        )}

        {showTemplate && (
          <Templates
            visible={showTemplate}
            quickReplies={chatReplyTemplates}
            toggleModal={handleTemplate}
            availabilityIntegration={availabilityIntegration}
            messages={chat?.messages}
            propertyId={propertyId}
            saveAsDraft={saveAsDraft}
            handleMessage={handleMessage}
            conversationId={chat?.conversationId}
            locale={locale}
            channelDetails={emailIntegration?.channelDetails}
            sendMessage={sendMessage}
          ></Templates>
        )}
      </Fragment>
    );
  }
);
export default Chat;
